import { api } from '@/lib/axios';

export interface DQELigne {
  designation: string;
  unite: string;
  quantite: number;
  prix_unitaire_estime: number | null;
}

export interface ExtractionAO {
  intitule: string;
  objet: string;
  maitre_ouvrage: string;
  type_marche: 'PUBLIC' | 'PRIVE' | 'GRE_A_GRE';
  wilaya: string;
  date_limite_depot: string | null;
  montant_estimatif: number | null;
  caution_soumission: number | null;
  delai_execution_mois: number | null;
  documents_requis: string[];
  criteres_evaluation: string[];
  dqe: DQELigne[];
  confiance_extraction: 'HAUTE' | 'MOYENNE' | 'FAIBLE';
  remarques: string;
}

export interface AnalyseAOResult {
  fichier: string;
  extraction: ExtractionAO;
  avertissement: string;
}

/** Téléverse un PDF d'AO au backend pour analyse IA (clé API côté serveur). */
export async function analyserAoPdf(file: File): Promise<AnalyseAOResult> {
  const form = new FormData();
  form.append('fichier', file);
  const { data } = await api.post<AnalyseAOResult>('/ia/analyser-ao', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120_000,
  });
  return data;
}
